/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useLocation } from "react-router-dom";
import {useEffect, useState} from "react";

// This custom hook returns an object with the URL parameters and their values
const useGetUrlParams = () => {
  const location = useLocation(); // get the current URL information
  const params = new URLSearchParams(location.search); // get the search string that starts with a question mark (?)
  const [urlParams, setUrlParams] = useState(Object.fromEntries(params)); // initialize the state with the params object

  useEffect(() => {
    setUrlParams(Object.fromEntries(params)); // update the state when the params object changes
  }, [location.search]); // run the effect when the URL search changes

  return urlParams; // return the state object
}

export default useGetUrlParams;